import { drawBlobDruidProcedural } from './blobMobs';

export function drawAmberClusterProcedural(
  ctx: CanvasRenderingContext2D,
  centerX: number,
  centerY: number,
  size: number,
  alpha: number,
  rotation: number = 0
): void {
  const coreR = size * 0.22;
  const glowR = size * 0.38;
  const dotR = size * 0.092;
  const orbit = size * 0.34;

  ctx.save();
  ctx.globalAlpha = alpha;
  ctx.translate(centerX, centerY);
  ctx.rotate((rotation * Math.PI) / 180);
  ctx.translate(-centerX, -centerY);
  ctx.shadowColor = 'rgba(250, 204, 21, 0.9)';
  ctx.shadowBlur = size * 0.33;

  ctx.beginPath();
  ctx.arc(centerX, centerY, glowR, 0, Math.PI * 2);
  ctx.fillStyle = 'rgba(234, 179, 8, 0.8)';
  ctx.fill();

  ctx.beginPath();
  ctx.arc(centerX, centerY, coreR, 0, Math.PI * 2);
  ctx.fillStyle = 'rgba(254, 240, 170, 0.78)';
  ctx.fill();

  ctx.shadowBlur = size * 0.12;
  for (let i = 0; i < 3; i += 1) {
    const angle = (-Math.PI / 2) + ((i - 1) * (Math.PI / 5.2));
    const x = centerX + Math.cos(angle) * orbit;
    const y = centerY + Math.sin(angle) * orbit;
    ctx.beginPath();
    ctx.arc(x, y, dotR, 0, Math.PI * 2);
    ctx.fillStyle = 'rgba(255, 255, 255, 0.97)';
    ctx.fill();
  }

  ctx.restore();
}

export function drawAnalystOrbProcedural(
  ctx: CanvasRenderingContext2D,
  centerX: number,
  centerY: number,
  size: number,
  alpha: number,
  rotation: number = 0
): void {
  drawBlobDruidProcedural(ctx, centerX, centerY, size, alpha, rotation);
}

export function drawCrimsonSunProcedural(
  ctx: CanvasRenderingContext2D,
  centerX: number,
  centerY: number,
  size: number,
  alpha: number,
  rotation: number = 0
): void {
  const visualRotation = rotation - 135;
  const spikeOuter = size * 0.38;
  const spikeInner = size * 0.23;
  const coreR = size * 0.16;
  const bodyR = size * 0.26;
  ctx.save();
  ctx.globalAlpha = alpha;
  ctx.translate(centerX, centerY);
  ctx.rotate((visualRotation * Math.PI) / 180);
  ctx.translate(-centerX, -centerY);
  ctx.shadowColor = 'rgba(127, 29, 29, 0.9)';
  ctx.shadowBlur = size * 0.3;
  ctx.beginPath();
  for (let i = 0; i < 16; i += 1) {
    const angle = (i * Math.PI) / 8;
    const r = i % 2 === 0 ? spikeOuter : spikeInner;
    const x = centerX + Math.cos(angle) * r;
    const y = centerY + Math.sin(angle) * r;
    if (i === 0) ctx.moveTo(x, y);
    else ctx.lineTo(x, y);
  }
  ctx.closePath();
  ctx.fillStyle = 'rgba(127, 29, 29, 0.72)';
  ctx.fill();
  ctx.beginPath();
  ctx.arc(centerX, centerY, bodyR, 0, Math.PI * 2);
  ctx.fillStyle = 'rgba(153, 27, 27, 0.9)';
  ctx.fill();
  ctx.beginPath();
  ctx.arc(centerX, centerY, coreR, 0, Math.PI * 2);
  ctx.fillStyle = 'rgba(248, 113, 113, 0.72)';
  ctx.fill();
  ctx.beginPath();
  ctx.arc(centerX + size * 0.18, centerY + size * 0.18, size * 0.08, 0, Math.PI * 2);
  ctx.fillStyle = 'rgba(255, 255, 255, 0.95)';
  ctx.fill();
  ctx.restore();
}

export function drawVioletRingProcedural(
  ctx: CanvasRenderingContext2D,
  centerX: number,
  centerY: number,
  size: number,
  alpha: number,
  rotation: number = 0
): void {
  const visualRotation = rotation + 54;
  ctx.save();
  ctx.globalAlpha = alpha;
  ctx.translate(centerX, centerY);
  ctx.rotate((visualRotation * Math.PI) / 180);
  ctx.translate(-centerX, -centerY);
  ctx.shadowColor = 'rgba(168, 85, 247, 0.9)';
  ctx.shadowBlur = size * 0.3;
  ctx.beginPath();
  ctx.arc(centerX, centerY, size * 0.38, 0, Math.PI * 2);
  ctx.fillStyle = 'rgba(88, 28, 135, 0.55)';
  ctx.fill();
  ctx.lineWidth = size * 0.07;
  ctx.strokeStyle = 'rgba(192, 132, 252, 0.95)';
  ctx.stroke();
  ctx.beginPath();
  ctx.arc(centerX, centerY, size * 0.2, 0, Math.PI * 2);
  ctx.fillStyle = 'rgba(196, 181, 253, 0.58)';
  ctx.fill();
  for (let i = 0; i < 3; i += 1) {
    const angle = Math.PI + i * (Math.PI / 5);
    ctx.beginPath();
    ctx.arc(centerX + Math.cos(angle) * size * 0.29, centerY + Math.sin(angle) * size * 0.29, size * 0.07, 0, Math.PI * 2);
    ctx.fillStyle = 'rgba(255,255,255,0.95)';
    ctx.fill();
  }
  ctx.restore();
}

export function drawAquaCoreProcedural(
  ctx: CanvasRenderingContext2D,
  centerX: number,
  centerY: number,
  size: number,
  alpha: number,
  rotation: number = 0
): void {
  ctx.save();
  ctx.globalAlpha = alpha;
  ctx.translate(centerX, centerY);
  ctx.rotate((rotation * Math.PI) / 180);
  ctx.translate(-centerX, -centerY);
  ctx.shadowColor = 'rgba(45, 212, 191, 0.9)';
  ctx.shadowBlur = size * 0.32;
  ctx.beginPath();
  ctx.arc(centerX, centerY, size * 0.38, 0, Math.PI * 2);
  ctx.fillStyle = 'rgba(34, 211, 238, 0.35)';
  ctx.fill();
  ctx.lineWidth = size * 0.07;
  ctx.strokeStyle = 'rgba(56, 189, 248, 0.6)';
  ctx.stroke();
  ctx.beginPath();
  ctx.arc(centerX, centerY, size * 0.22, 0, Math.PI * 2);
  ctx.fillStyle = 'rgba(186, 230, 253, 0.95)';
  ctx.fill();
  for (let i = 0; i < 3; i += 1) {
    const angle = -Math.PI / 2 + i * ((2 * Math.PI) / 3);
    const radius = i === 0 ? size * 0.085 : size * 0.072;
    ctx.beginPath();
    ctx.arc(centerX + Math.cos(angle) * size * 0.24, centerY + Math.sin(angle) * size * 0.24, radius, 0, Math.PI * 2);
    if (i === 0) {
      ctx.shadowColor = 'rgba(186, 230, 253, 1)';
      ctx.shadowBlur = size * 0.18;
      ctx.fillStyle = 'rgba(186, 230, 253, 1)';
    } else {
      ctx.shadowBlur = 0;
      ctx.fillStyle = 'rgba(125, 211, 252, 0.72)';
    }
    ctx.fill();
    if (i === 0) {
      const eyeX = centerX + Math.cos(angle) * size * 0.24;
      const eyeY = centerY + Math.sin(angle) * size * 0.24;
      const eyeRadius = size * 0.085;
      const pupilRadius = eyeRadius * 0.5;
      ctx.shadowBlur = 0;
      ctx.beginPath();
      ctx.arc(eyeX, eyeY - eyeRadius * 0.5, pupilRadius, 0, Math.PI * 2);
      ctx.fillStyle = 'rgba(0, 0, 0, 0.92)';
      ctx.fill();
    }
  }
  ctx.restore();
}

export function drawVerdantNodeProcedural(
  ctx: CanvasRenderingContext2D,
  centerX: number,
  centerY: number,
  size: number,
  alpha: number,
  rotation: number = 0
): void {
  ctx.save();
  ctx.globalAlpha = alpha;
  ctx.translate(centerX, centerY);
  ctx.rotate((rotation * Math.PI) / 180);
  ctx.translate(-centerX, -centerY);
  ctx.shadowColor = 'rgba(34, 197, 94, 0.9)';
  ctx.shadowBlur = size * 0.3;
  ctx.beginPath();
  ctx.arc(centerX, centerY, size * 0.38, 0, Math.PI * 2);
  ctx.fillStyle = 'rgba(22, 163, 74, 0.35)';
  ctx.fill();
  ctx.beginPath();
  ctx.arc(centerX, centerY, size * 0.31, 0, Math.PI * 2);
  ctx.fillStyle = 'rgba(134, 239, 172, 0.52)';
  ctx.fill();
  const offsets: [number, number][] = [[0, -1], [1, 0], [0, 1], [-1, 0]];
  for (let i = 0; i < offsets.length; i += 1) {
    const [dx, dy] = offsets[i];
    const isPrimary = i === 0;
    ctx.beginPath();
    ctx.arc(
      centerX + dx * size * 0.26,
      centerY + dy * size * 0.26,
      isPrimary ? size * 0.09 : size * 0.06,
      0,
      Math.PI * 2
    );
    ctx.fillStyle = isPrimary ? 'rgba(220, 252, 231, 0.98)' : 'rgba(255,255,255,0.86)';
    ctx.fill();
    if (isPrimary) {
      const eyeX = centerX + dx * size * 0.26;
      const eyeY = centerY + dy * size * 0.26;
      const eyeRadius = size * 0.09;
      const pupilRadius = eyeRadius * 0.5;
      ctx.beginPath();
      ctx.arc(eyeX, eyeY - eyeRadius * 0.5, pupilRadius, 0, Math.PI * 2);
      ctx.fillStyle = 'rgba(0, 0, 0, 0.92)';
      ctx.fill();
    }
  }
  ctx.restore();
}

export function drawEmberClusterProcedural(
  ctx: CanvasRenderingContext2D,
  centerX: number,
  centerY: number,
  size: number,
  alpha: number,
  rotation: number = 0
): void {
  const visualRotation = rotation - 45;
  ctx.save();
  ctx.globalAlpha = alpha;
  ctx.translate(centerX, centerY);
  ctx.rotate((visualRotation * Math.PI) / 180);
  ctx.translate(-centerX, -centerY);
  ctx.shadowColor = 'rgba(251, 146, 60, 0.95)';
  ctx.shadowBlur = size * 0.33;
  ctx.beginPath();
  ctx.arc(centerX, centerY, size * 0.34, 0, Math.PI * 2);
  ctx.fillStyle = 'rgba(249, 115, 22, 0.88)';
  ctx.fill();
  ctx.beginPath();
  ctx.arc(centerX, centerY, size * 0.19, 0, Math.PI * 2);
  ctx.fillStyle = 'rgba(254, 215, 170, 0.7)';
  ctx.fill();
  ctx.beginPath();
  ctx.arc(centerX + size * 0.2, centerY - size * 0.19, size * 0.1, 0, Math.PI * 2);
  ctx.fillStyle = 'rgba(255,255,255,0.95)';
  ctx.fill();
  ctx.beginPath();
  ctx.arc(centerX - size * 0.2, centerY + size * 0.2, size * 0.07, 0, Math.PI * 2);
  ctx.fillStyle = 'rgba(255,255,255,0.95)';
  ctx.fill();
  ctx.restore();
}

export function drawPrismHaloProcedural(
  ctx: CanvasRenderingContext2D,
  centerX: number,
  centerY: number,
  size: number,
  alpha: number,
  rotation: number = 0
): void {
  ctx.save();
  ctx.globalAlpha = alpha;
  ctx.translate(centerX, centerY);
  ctx.rotate((rotation * Math.PI) / 180);
  ctx.translate(-centerX, -centerY);
  ctx.shadowColor = 'rgba(45, 212, 191, 0.9)';
  ctx.shadowBlur = size * 0.32;
  ctx.beginPath();
  ctx.arc(centerX, centerY, size * 0.37, 0, Math.PI * 2);
  ctx.fillStyle = 'rgba(12, 74, 110, 0.3)';
  ctx.fill();
  ctx.lineWidth = size * 0.06;
  ctx.strokeStyle = 'rgba(103, 232, 249, 0.8)';
  ctx.stroke();
  for (let i = 0; i < 6; i += 1) {
    const angle = -Math.PI / 2 + i * (Math.PI / 3);
    const r = size * 0.24;
    const px = centerX + Math.cos(angle) * r;
    const py = centerY + Math.sin(angle) * r;
    ctx.beginPath();
    ctx.arc(px, py, size * 0.05, 0, Math.PI * 2);
    ctx.fillStyle = i === 0 ? 'rgba(125, 211, 252, 1)' : 'rgba(186, 230, 253, 0.8)';
    ctx.fill();
  }
  ctx.restore();
}

export function drawVoidEyeProcedural(
  ctx: CanvasRenderingContext2D,
  centerX: number,
  centerY: number,
  size: number,
  alpha: number,
  rotation: number = 0
): void {
  ctx.save();
  ctx.globalAlpha = alpha;
  ctx.translate(centerX, centerY);
  ctx.rotate((rotation * Math.PI) / 180);
  ctx.translate(-centerX, -centerY);
  ctx.shadowColor = 'rgba(196, 181, 253, 0.75)';
  ctx.shadowBlur = size * 0.3;
  ctx.beginPath();
  ctx.arc(centerX, centerY, size * 0.36, 0, Math.PI * 2);
  ctx.fillStyle = 'rgba(30, 27, 75, 0.72)';
  ctx.fill();
  ctx.beginPath();
  ctx.arc(centerX, centerY, size * 0.2, 0, Math.PI * 2);
  ctx.fillStyle = 'rgba(0, 0, 0, 0.88)';
  ctx.fill();
  const eyeX = centerX;
  const eyeY = centerY - size * 0.26;
  ctx.beginPath();
  ctx.arc(eyeX, eyeY, size * 0.09, 0, Math.PI * 2);
  ctx.fillStyle = 'rgba(233, 213, 255, 0.95)';
  ctx.fill();
  ctx.beginPath();
  ctx.arc(eyeX, eyeY - size * 0.045, size * 0.045, 0, Math.PI * 2);
  ctx.fillStyle = 'rgba(0, 0, 0, 0.9)';
  ctx.fill();
  ctx.restore();
}

export function drawSolarFloretProcedural(
  ctx: CanvasRenderingContext2D,
  centerX: number,
  centerY: number,
  size: number,
  alpha: number,
  rotation: number = 0
): void {
  ctx.save();
  ctx.globalAlpha = alpha;
  ctx.translate(centerX, centerY);
  ctx.rotate((rotation * Math.PI) / 180);
  ctx.translate(-centerX, -centerY);
  ctx.shadowColor = 'rgba(251, 191, 36, 0.9)';
  ctx.shadowBlur = size * 0.34;
  for (let i = 0; i < 8; i += 1) {
    const angle = -Math.PI / 2 + i * (Math.PI / 4);
    const px = centerX + Math.cos(angle) * size * 0.19;
    const py = centerY + Math.sin(angle) * size * 0.19;
    ctx.beginPath();
    ctx.arc(px, py, size * 0.11, 0, Math.PI * 2);
    ctx.fillStyle = 'rgba(249, 115, 22, 0.72)';
    ctx.fill();
  }
  ctx.beginPath();
  ctx.arc(centerX, centerY, size * 0.21, 0, Math.PI * 2);
  ctx.fillStyle = 'rgba(254, 243, 199, 0.82)';
  ctx.fill();
  ctx.beginPath();
  ctx.arc(centerX, centerY - size * 0.24, size * 0.06, 0, Math.PI * 2);
  ctx.fillStyle = 'rgba(255, 251, 235, 0.95)';
  ctx.fill();
  ctx.restore();
}

export function drawRuneGyreProcedural(
  ctx: CanvasRenderingContext2D,
  centerX: number,
  centerY: number,
  size: number,
  alpha: number,
  rotation: number = 0
): void {
  ctx.save();
  ctx.globalAlpha = alpha;
  ctx.translate(centerX, centerY);
  ctx.rotate((rotation * Math.PI) / 180);
  ctx.translate(-centerX, -centerY);
  ctx.shadowColor = 'rgba(167, 139, 250, 0.9)';
  ctx.shadowBlur = size * 0.28;
  ctx.beginPath();
  ctx.arc(centerX, centerY, size * 0.34, 0, Math.PI * 2);
  ctx.fillStyle = 'rgba(49, 46, 129, 0.6)';
  ctx.fill();
  ctx.lineWidth = size * 0.04;
  ctx.strokeStyle = 'rgba(196, 181, 253, 0.75)';
  for (let i = 0; i < 3; i += 1) {
    const start = (-Math.PI / 2) + i * (2 * Math.PI / 3);
    ctx.beginPath();
    ctx.arc(centerX, centerY, size * (0.14 + i * 0.06), start, start + Math.PI);
    ctx.stroke();
  }
  ctx.beginPath();
  ctx.arc(centerX, centerY - size * 0.25, size * 0.055, 0, Math.PI * 2);
  ctx.fillStyle = 'rgba(255, 255, 255, 0.94)';
  ctx.fill();
  ctx.restore();
}

export function drawGlacierSigilProcedural(
  ctx: CanvasRenderingContext2D,
  centerX: number,
  centerY: number,
  size: number,
  alpha: number,
  rotation: number = 0
): void {
  const visualRotation = rotation + 30;
  ctx.save();
  ctx.globalAlpha = alpha;
  ctx.translate(centerX, centerY);
  ctx.rotate((visualRotation * Math.PI) / 180);
  ctx.translate(-centerX, -centerY);
  ctx.shadowColor = 'rgba(125, 211, 252, 0.95)';
  ctx.shadowBlur = size * 0.33;
  for (let i = 0; i < 6; i += 1) {
    const angle = (i * Math.PI) / 3;
    const innerX = centerX + Math.cos(angle) * size * 0.08;
    const innerY = centerY + Math.sin(angle) * size * 0.08;
    const tipX = centerX + Math.cos(angle) * size * 0.38;
    const tipY = centerY + Math.sin(angle) * size * 0.38;
    const sideAngle = angle + Math.PI / 2;
    const side = size * 0.04;
    ctx.beginPath();
    ctx.moveTo(innerX + Math.cos(sideAngle) * side, innerY + Math.sin(sideAngle) * side);
    ctx.lineTo(tipX, tipY);
    ctx.lineTo(innerX - Math.cos(sideAngle) * side, innerY - Math.sin(sideAngle) * side);
    ctx.closePath();
    ctx.fillStyle = 'rgba(103, 232, 249, 0.75)';
    ctx.fill();
  }
  ctx.beginPath();
  ctx.arc(centerX, centerY, size * 0.18, 0, Math.PI * 2);
  ctx.fillStyle = 'rgba(224, 242, 254, 0.95)';
  ctx.fill();
  ctx.beginPath();
  ctx.arc(centerX, centerY - size * 0.08, size * 0.045, 0, Math.PI * 2);
  ctx.fillStyle = 'rgba(15, 23, 42, 0.88)';
  ctx.fill();
  ctx.restore();
}

export function drawToxicCometProcedural(
  ctx: CanvasRenderingContext2D,
  centerX: number,
  centerY: number,
  size: number,
  alpha: number,
  rotation: number = 0
): void {
  const visualRotation = rotation - 20;
  ctx.save();
  ctx.globalAlpha = alpha;
  ctx.translate(centerX, centerY);
  ctx.rotate((visualRotation * Math.PI) / 180);
  ctx.translate(-centerX, -centerY);
  ctx.shadowColor = 'rgba(132, 204, 22, 0.95)';
  ctx.shadowBlur = size * 0.35;
  ctx.beginPath();
  ctx.moveTo(centerX - size * 0.33, centerY + size * 0.2);
  ctx.quadraticCurveTo(centerX - size * 0.06, centerY + size * 0.24, centerX + size * 0.18, centerY + size * 0.08);
  ctx.quadraticCurveTo(centerX - size * 0.07, centerY + size * 0.09, centerX - size * 0.31, centerY + size * 0.02);
  ctx.closePath();
  ctx.fillStyle = 'rgba(101, 163, 13, 0.68)';
  ctx.fill();
  ctx.beginPath();
  ctx.arc(centerX + size * 0.12, centerY - size * 0.02, size * 0.2, 0, Math.PI * 2);
  ctx.fillStyle = 'rgba(163, 230, 53, 0.9)';
  ctx.fill();
  ctx.beginPath();
  ctx.arc(centerX + size * 0.2, centerY - size * 0.12, size * 0.08, 0, Math.PI * 2);
  ctx.fillStyle = 'rgba(254, 255, 240, 0.97)';
  ctx.fill();
  ctx.beginPath();
  ctx.arc(centerX + size * 0.2, centerY - size * 0.155, size * 0.032, 0, Math.PI * 2);
  ctx.fillStyle = 'rgba(23, 23, 23, 0.94)';
  ctx.fill();
  ctx.restore();
}

export function drawIronMawProcedural(
  ctx: CanvasRenderingContext2D,
  centerX: number,
  centerY: number,
  size: number,
  alpha: number,
  rotation: number = 0
): void {
  ctx.save();
  ctx.globalAlpha = alpha;
  ctx.translate(centerX, centerY);
  ctx.rotate((rotation * Math.PI) / 180);
  ctx.translate(-centerX, -centerY);
  ctx.shadowColor = 'rgba(156, 163, 175, 0.92)';
  ctx.shadowBlur = size * 0.3;
  ctx.beginPath();
  ctx.moveTo(centerX, centerY - size * 0.37);
  ctx.lineTo(centerX + size * 0.34, centerY - size * 0.08);
  ctx.lineTo(centerX + size * 0.22, centerY + size * 0.33);
  ctx.lineTo(centerX - size * 0.22, centerY + size * 0.33);
  ctx.lineTo(centerX - size * 0.34, centerY - size * 0.08);
  ctx.closePath();
  ctx.fillStyle = 'rgba(75, 85, 99, 0.86)';
  ctx.fill();
  ctx.beginPath();
  ctx.arc(centerX, centerY + size * 0.03, size * 0.17, 0, Math.PI);
  ctx.lineTo(centerX - size * 0.17, centerY + size * 0.03);
  ctx.fillStyle = 'rgba(17, 24, 39, 0.95)';
  ctx.fill();
  for (let i = -2; i <= 2; i += 1) {
    const toothX = centerX + i * size * 0.06;
    ctx.beginPath();
    ctx.moveTo(toothX - size * 0.018, centerY + size * 0.03);
    ctx.lineTo(toothX, centerY + size * 0.13);
    ctx.lineTo(toothX + size * 0.018, centerY + size * 0.03);
    ctx.closePath();
    ctx.fillStyle = 'rgba(229, 231, 235, 0.95)';
    ctx.fill();
  }
  ctx.beginPath();
  ctx.arc(centerX, centerY - size * 0.24, size * 0.055, 0, Math.PI * 2);
  ctx.fillStyle = 'rgba(255, 255, 255, 0.96)';
  ctx.fill();
  ctx.beginPath();
  ctx.arc(centerX, centerY - size * 0.27, size * 0.026, 0, Math.PI * 2);
  ctx.fillStyle = 'rgba(0, 0, 0, 0.92)';
  ctx.fill();
  ctx.restore();
}

export function drawDuskSeraphProcedural(
  ctx: CanvasRenderingContext2D,
  centerX: number,
  centerY: number,
  size: number,
  alpha: number,
  rotation: number = 0
): void {
  const visualRotation = rotation + 90;
  ctx.save();
  ctx.globalAlpha = alpha;
  ctx.translate(centerX, centerY);
  ctx.rotate((visualRotation * Math.PI) / 180);
  ctx.translate(-centerX, -centerY);
  ctx.shadowColor = 'rgba(251, 191, 36, 0.85)';
  ctx.shadowBlur = size * 0.34;
  for (let i = 0; i < 2; i += 1) {
    const side = i === 0 ? -1 : 1;
    ctx.beginPath();
    ctx.moveTo(centerX + side * size * 0.06, centerY - size * 0.02);
    ctx.quadraticCurveTo(centerX + side * size * 0.36, centerY - size * 0.16, centerX + side * size * 0.29, centerY + size * 0.18);
    ctx.quadraticCurveTo(centerX + side * size * 0.18, centerY + size * 0.09, centerX + side * size * 0.02, centerY + size * 0.2);
    ctx.closePath();
    ctx.fillStyle = 'rgba(244, 114, 182, 0.58)';
    ctx.fill();
  }
  ctx.beginPath();
  ctx.arc(centerX, centerY, size * 0.2, 0, Math.PI * 2);
  ctx.fillStyle = 'rgba(251, 207, 232, 0.82)';
  ctx.fill();
  ctx.beginPath();
  ctx.arc(centerX + size * 0.18, centerY, size * 0.07, 0, Math.PI * 2);
  ctx.fillStyle = 'rgba(255, 255, 255, 0.95)';
  ctx.fill();
  ctx.beginPath();
  ctx.arc(centerX + size * 0.21, centerY, size * 0.03, 0, Math.PI * 2);
  ctx.fillStyle = 'rgba(30, 27, 75, 0.92)';
  ctx.fill();
  ctx.restore();
}

export function drawFrostShardProcedural(
  ctx: CanvasRenderingContext2D,
  centerX: number,
  centerY: number,
  size: number,
  alpha: number,
  rotation: number = 0
): void {
  ctx.save();
  ctx.globalAlpha = alpha;
  ctx.translate(centerX, centerY);
  ctx.rotate((rotation * Math.PI) / 180);
  ctx.translate(-centerX, -centerY);

  ctx.shadowColor = 'rgba(186, 230, 253, 0.9)';
  ctx.shadowBlur = size * 0.28;

  const outerR = size * 0.38;
  const innerR = size * 0.18;
  ctx.beginPath();
  for (let i = 0; i < 12; i += 1) {
    const angle = (i * Math.PI) / 6 - Math.PI / 6;
    const r = i % 2 === 0 ? outerR : innerR;
    const x = centerX + Math.cos(angle) * r;
    const y = centerY + Math.sin(angle) * r;
    if (i === 0) ctx.moveTo(x, y);
    else ctx.lineTo(x, y);
  }
  ctx.closePath();
  ctx.fillStyle = 'rgba(186, 230, 253, 0.72)';
  ctx.fill();
  ctx.lineWidth = size * 0.025;
  ctx.strokeStyle = 'rgba(255, 255, 255, 0.9)';
  ctx.stroke();

  ctx.shadowBlur = 0;
  ctx.lineWidth = size * 0.015;
  ctx.strokeStyle = 'rgba(255, 255, 255, 0.6)';
  for (let i = 0; i < 6; i += 1) {
    const angle = (i * Math.PI) / 3 - Math.PI / 6;
    ctx.beginPath();
    ctx.moveTo(centerX, centerY);
    ctx.lineTo(centerX + Math.cos(angle) * outerR, centerY + Math.sin(angle) * outerR);
    ctx.stroke();
  }

  ctx.beginPath();
  ctx.arc(centerX, centerY, size * 0.1, 0, Math.PI * 2);
  ctx.fillStyle = 'rgba(240, 249, 255, 0.95)';
  ctx.fill();

  ctx.restore();
}

export function drawMagmaVentProcedural(
  ctx: CanvasRenderingContext2D,
  centerX: number,
  centerY: number,
  size: number,
  alpha: number,
  rotation: number = 0
): void {
  ctx.save();
  ctx.globalAlpha = alpha;
  ctx.translate(centerX, centerY);
  ctx.rotate((rotation * Math.PI) / 180);
  ctx.translate(-centerX, -centerY);

  ctx.shadowColor = 'rgba(239, 68, 68, 0.85)';
  ctx.shadowBlur = size * 0.3;

  const blobR = size * 0.35;
  const bumps = [0, 0.08, -0.06, 0.1, -0.04, 0.07, -0.09, 0.05];
  ctx.beginPath();
  for (let i = 0; i < 8; i += 1) {
    const angle = (i / 8) * Math.PI * 2 - Math.PI / 2;
    const r = blobR * (1 + bumps[i]);
    const x = centerX + Math.cos(angle) * r;
    const y = centerY + Math.sin(angle) * r;
    if (i === 0) ctx.moveTo(x, y);
    else ctx.lineTo(x, y);
  }
  ctx.closePath();
  ctx.fillStyle = 'rgba(127, 29, 29, 0.88)';
  ctx.fill();

  ctx.shadowBlur = size * 0.18;
  ctx.shadowColor = 'rgba(251, 146, 60, 1)';
  ctx.lineWidth = size * 0.028;
  ctx.strokeStyle = 'rgba(251, 146, 60, 0.9)';
  const crackAngles = [20, 95, 170, 245, 310];
  for (const deg of crackAngles) {
    const rad = (deg * Math.PI) / 180;
    ctx.beginPath();
    ctx.moveTo(centerX, centerY);
    ctx.lineTo(centerX + Math.cos(rad) * blobR * 0.82, centerY + Math.sin(rad) * blobR * 0.82);
    ctx.stroke();
  }

  ctx.shadowBlur = size * 0.1;
  ctx.shadowColor = 'rgba(254, 215, 170, 1)';
  const eyePositions: [number, number][] = [
    [centerX - size * 0.1, centerY - size * 0.1],
    [centerX + size * 0.1, centerY - size * 0.1],
  ];
  for (const [ex, ey] of eyePositions) {
    ctx.beginPath();
    ctx.arc(ex, ey, size * 0.065, 0, Math.PI * 2);
    ctx.fillStyle = 'rgba(254, 215, 170, 0.95)';
    ctx.fill();
    ctx.beginPath();
    ctx.arc(ex, ey - size * 0.03, size * 0.032, 0, Math.PI * 2);
    ctx.fillStyle = 'rgba(0, 0, 0, 0.88)';
    ctx.fill();
  }

  ctx.restore();
}

export function drawPlagueWispProcedural(
  ctx: CanvasRenderingContext2D,
  centerX: number,
  centerY: number,
  size: number,
  alpha: number,
  rotation: number = 0
): void {
  ctx.save();
  ctx.globalAlpha = alpha;
  ctx.translate(centerX, centerY);
  ctx.rotate((rotation * Math.PI) / 180);
  ctx.translate(-centerX, -centerY);

  ctx.shadowColor = 'rgba(163, 230, 53, 0.85)';
  ctx.shadowBlur = size * 0.28;

  ctx.beginPath();
  ctx.arc(centerX, centerY, size * 0.38, 0, Math.PI * 2);
  ctx.fillStyle = 'rgba(77, 124, 15, 0.28)';
  ctx.fill();

  ctx.shadowBlur = size * 0.1;
  for (let i = 0; i < 10; i += 1) {
    const angle = -Math.PI / 2 + (i / 10) * Math.PI * 2;
    const spiralR = size * (0.22 + (i % 3) * 0.024);
    const dotX = centerX + Math.cos(angle) * spiralR;
    const dotY = centerY + Math.sin(angle) * spiralR * 0.82;
    const dotSize = i === 0 ? size * 0.052 : size * 0.035;
    ctx.beginPath();
    ctx.arc(dotX, dotY, dotSize, 0, Math.PI * 2);
    ctx.fillStyle = i < 3 ? 'rgba(190, 242, 100, 0.95)' : 'rgba(132, 204, 22, 0.78)';
    ctx.fill();
  }

  ctx.shadowBlur = size * 0.2;
  ctx.shadowColor = 'rgba(190, 242, 100, 0.9)';
  ctx.beginPath();
  ctx.arc(centerX, centerY, size * 0.15, 0, Math.PI * 2);
  ctx.fillStyle = 'rgba(101, 163, 13, 0.9)';
  ctx.fill();

  ctx.shadowBlur = 0;
  ctx.beginPath();
  ctx.ellipse(centerX, centerY, size * 0.038, size * 0.075, 0, 0, Math.PI * 2);
  ctx.fillStyle = 'rgba(0, 0, 0, 0.92)';
  ctx.fill();
  ctx.beginPath();
  ctx.ellipse(centerX, centerY, size * 0.014, size * 0.038, 0, 0, Math.PI * 2);
  ctx.fillStyle = 'rgba(190, 242, 100, 0.9)';
  ctx.fill();

  ctx.restore();
}

export function drawCoralBloomProcedural(
  ctx: CanvasRenderingContext2D,
  centerX: number,
  centerY: number,
  size: number,
  alpha: number,
  rotation: number = 0
): void {
  ctx.save();
  ctx.globalAlpha = alpha;
  ctx.translate(centerX, centerY);
  ctx.rotate((rotation * Math.PI) / 180);
  ctx.translate(-centerX, -centerY);

  ctx.shadowColor = 'rgba(251, 113, 133, 0.85)';
  ctx.shadowBlur = size * 0.3;

  const petalOrbit = size * 0.22;
  const petalR = size * 0.16;
  for (let i = 0; i < 5; i += 1) {
    const angle = -Math.PI / 2 + (i / 5) * Math.PI * 2;
    const px = centerX + Math.cos(angle) * petalOrbit;
    const py = centerY + Math.sin(angle) * petalOrbit;
    ctx.beginPath();
    ctx.arc(px, py, petalR, 0, Math.PI * 2);
    ctx.fillStyle = i % 2 === 0 ? 'rgba(251, 113, 133, 0.88)' : 'rgba(244, 63, 94, 0.75)';
    ctx.fill();
  }

  ctx.shadowBlur = size * 0.1;
  for (let i = 0; i < 5; i += 1) {
    const angle = -Math.PI / 2 + (i / 5) * Math.PI * 2;
    const tipX = centerX + Math.cos(angle) * (petalOrbit + petalR * 0.65);
    const tipY = centerY + Math.sin(angle) * (petalOrbit + petalR * 0.65);
    ctx.beginPath();
    ctx.arc(tipX, tipY, size * 0.045, 0, Math.PI * 2);
    ctx.fillStyle = 'rgba(255, 228, 230, 0.9)';
    ctx.fill();
  }

  ctx.shadowBlur = size * 0.15;
  ctx.shadowColor = 'rgba(255, 241, 242, 0.9)';
  ctx.beginPath();
  ctx.arc(centerX, centerY, size * 0.14, 0, Math.PI * 2);
  ctx.fillStyle = 'rgba(255, 228, 230, 0.95)';
  ctx.fill();

  ctx.restore();
}

export function drawShadowKnotProcedural(
  ctx: CanvasRenderingContext2D,
  centerX: number,
  centerY: number,
  size: number,
  alpha: number,
  rotation: number = 0
): void {
  ctx.save();
  ctx.globalAlpha = alpha;
  ctx.translate(centerX, centerY);
  ctx.rotate((rotation * Math.PI) / 180);

  ctx.shadowColor = 'rgba(99, 102, 241, 0.8)';
  ctx.shadowBlur = size * 0.28;

  const armW = size * 0.18;
  const armL = size * 0.72;

  const drawArm = (angleDeg: number) => {
    ctx.save();
    ctx.rotate((angleDeg * Math.PI) / 180);
    const hw = armW / 2;
    const hl = armL / 2;
    const r = hw * 0.6;
    ctx.beginPath();
    ctx.moveTo(-hl + r, -hw);
    ctx.lineTo(hl - r, -hw);
    ctx.arcTo(hl, -hw, hl, -hw + r, r);
    ctx.lineTo(hl, hw - r);
    ctx.arcTo(hl, hw, hl - r, hw, r);
    ctx.lineTo(-hl + r, hw);
    ctx.arcTo(-hl, hw, -hl, hw - r, r);
    ctx.lineTo(-hl, -hw + r);
    ctx.arcTo(-hl, -hw, -hl + r, -hw, r);
    ctx.closePath();
    ctx.fillStyle = 'rgba(15, 10, 40, 0.92)';
    ctx.fill();
    ctx.lineWidth = size * 0.03;
    ctx.strokeStyle = 'rgba(129, 140, 248, 0.75)';
    ctx.stroke();
    ctx.restore();
  };

  drawArm(45);
  drawArm(-45);

  ctx.shadowBlur = size * 0.12;
  ctx.shadowColor = 'rgba(196, 181, 253, 1)';
  const eyeOffsets: [number, number][] = [
    [-size * 0.08, -size * 0.08],
    [size * 0.08, size * 0.08],
  ];
  for (const [ex, ey] of eyeOffsets) {
    ctx.beginPath();
    ctx.arc(ex, ey, size * 0.042, 0, Math.PI * 2);
    ctx.fillStyle = 'rgba(233, 213, 255, 0.97)';
    ctx.fill();
  }

  ctx.restore();
}

export function drawArcLensProcedural(
  ctx: CanvasRenderingContext2D,
  centerX: number,
  centerY: number,
  size: number,
  alpha: number,
  rotation: number = 0
): void {
  ctx.save();
  ctx.globalAlpha = alpha;
  ctx.translate(centerX, centerY);
  ctx.rotate((rotation * Math.PI) / 180);
  ctx.translate(-centerX, -centerY);

  ctx.shadowColor = 'rgba(34, 211, 238, 0.85)';
  ctx.shadowBlur = size * 0.26;

  const rings = [
    { rx: size * 0.38, ry: size * 0.28, color: 'rgba(103, 232, 249, 0.65)', lw: size * 0.03 },
    { rx: size * 0.28, ry: size * 0.21, color: 'rgba(34, 211, 238, 0.75)', lw: size * 0.025 },
    { rx: size * 0.18, ry: size * 0.14, color: 'rgba(186, 230, 253, 0.85)', lw: size * 0.02 },
  ];
  for (const ring of rings) {
    ctx.beginPath();
    ctx.ellipse(centerX, centerY, ring.rx, ring.ry, 0, 0, Math.PI * 2);
    ctx.lineWidth = ring.lw;
    ctx.strokeStyle = ring.color;
    ctx.stroke();
  }

  ctx.beginPath();
  ctx.ellipse(centerX, centerY, size * 0.38, size * 0.28, 0, 0, Math.PI * 2);
  ctx.fillStyle = 'rgba(8, 145, 178, 0.1)';
  ctx.fill();

  ctx.shadowBlur = size * 0.14;
  ctx.shadowColor = 'rgba(186, 230, 253, 0.95)';
  ctx.beginPath();
  ctx.arc(centerX, centerY, size * 0.095, 0, Math.PI * 2);
  ctx.fillStyle = 'rgba(224, 242, 254, 0.97)';
  ctx.fill();
  ctx.shadowBlur = 0;
  ctx.beginPath();
  ctx.arc(centerX, centerY, size * 0.05, 0, Math.PI * 2);
  ctx.fillStyle = 'rgba(7, 89, 133, 0.95)';
  ctx.fill();
  ctx.beginPath();
  ctx.arc(centerX - size * 0.025, centerY - size * 0.025, size * 0.022, 0, Math.PI * 2);
  ctx.fillStyle = 'rgba(255, 255, 255, 0.95)';
  ctx.fill();

  ctx.restore();
}
